import React, { Component } from "react";
import { Container } from "./styles.js";
import CircularProgress from "@material-ui/core/CircularProgress";

class Loading extends Component {
  render() {
    return (
      <Container modal={this.props.modal} transparent={this.props.transparent}>
        <CircularProgress size={100} style={{ color: "#1890ff" }} />
      </Container>
    );
  }
}

export default Loading;



// WEBPACK FOOTER //
// ./src/components/LoadingChat/index.js